<template>
    <!-- wrap -->
    <div id="wrap" class="has-step">
        <!-- header -->
        <div id="header">
            <div class="container">
                <div class="header-top">
                    <div class="back">
                        <a @click="backbtn"><i /><span class="blind">뒤로가기</span></a>
                        <span>페이스매핑 등록</span>
                    </div>

                    <div class="header-nav">
                        <a class="btn btn-home" @click="home"><i /><span class="blind">홈으로</span></a>
                    </div>
                </div>

                <div class="step-box">
                    <ul>
                        <li @click="prevStep()">
                            <span>STEP1. 현장정보</span>
                        </li>
                        <li class="on">
                            <span>STEP2. 막장 사진대지</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- // header -->

        <!-- content-wrap -->
        <main id="content-wrap">
            <div id="contents">
                <div class="photo-upload-form">
                    <div class="photo-upload-box">
                        <p class="tit">
                            천단부
                        </p>
                        <div class="photo-inbox-wrapper">
                            <div class="photo-inbox ratio-type-1">
                                <div v-if="imageSrc[1] != null" class="photo-img">
                                    <img v-gallery:detail :src="imageSrc[1]" />
                                    <button
                                        type="button"
                                        class="photo-delete"
                                        style="width: 29px;height: 29px;top:45%;left:45%;"
                                        @click="imageDelete(1)"
                                    >
                                        <span class="blind">사진 삭제</span>
                                    </button>
                                </div>

                                <label v-else class="photo-upload-label" for="photo-upload-1" @click="imageUpload(1)">
                                    <span class="blind">사진 업로드</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div v-show="false" class="photo-upload-box cnt-2">
                        <p class="tit">
                            좌측 아치부
                        </p>
                        <div class="photo-inbox-wrapper cnt-2">
                            <div class="photo-inbox ratio-type-2">
                                <div v-if="imageSrc[2] != null" class="photo-img">
                                    <img v-gallery:detail :src="imageSrc[2]" />
                                    <button
                                        type="button"
                                        class="photo-delete"
                                        style="width: 29px;height: 29px;top:45%;left:45%;"
                                        @click="imageDelete(2)"
                                    >
                                        <span class="blind">사진 삭제</span>
                                    </button>
                                </div>

                                <label v-else class="photo-upload-label" for="photo-upload-2" @click="imageUpload(2)">
                                    <span class="blind">사진 업로드</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div v-show="false" class="photo-upload-box cnt-2">
                        <p class="tit">
                            우측 아치부
                        </p>
                        <div class="photo-inbox-wrapper cnt-2">
                            <div class="photo-inbox ratio-type-2">
                                <div v-if="imageSrc[3] != null" class="photo-img">
                                    <img v-gallery:detail :src="imageSrc[3]" />
                                    <button
                                        type="button"
                                        class="photo-delete"
                                        style="width: 29px;height: 29px;top:45%;left:45%;"
                                        @click="imageDelete(3)"
                                    >
                                        <span class="blind">사진 삭제</span>
                                    </button>
                                </div>

                                <label v-else class="photo-upload-label" for="photo-upload-3" @click="imageUpload(3)">
                                    <span class="blind">사진 업로드</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="photo-upload-box">
                        <p class="tit">
                            막장면
                        </p>
                        <div class="photo-inbox-wrapper">
                            <div class="photo-inbox ratio-type-1">
                                <div v-if="imageSrc[4] != null" class="photo-img">
                                    <img v-gallery:detail :src="imageSrc[4]" />
                                    <button
                                        type="button"
                                        class="photo-delete"
                                        style="width: 29px;height: 29px;top:45%;left:45%;"
                                        @click="imageDelete(4)"
                                    >
                                        <span class="blind">사진 삭제</span>
                                    </button>
                                </div>

                                <label v-else class="photo-upload-label" for="photo-upload-4" @click="imageUpload(4)">
                                    <span class="blind">사진 업로드</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="photo-upload-box cnt-2">
                        <p class="tit">
                            좌측면
                        </p>
                        <div class="photo-inbox-wrapper cnt-2">
                            <div class="photo-inbox ratio-type-2">
                                <div v-if="imageSrc[5] != null" class="photo-img">
                                    <img v-gallery:detail :src="imageSrc[5]" />
                                    <button
                                        type="button"
                                        class="photo-delete"
                                        style="width: 29px;height: 29px;top:45%;left:45%;"
                                        @click="imageDelete(5)"
                                    >
                                        <span class="blind">사진 삭제</span>
                                    </button>
                                </div>

                                <label v-else class="photo-upload-label" for="photo-upload-5" @click="imageUpload(5)">
                                    <span class="blind">사진 업로드</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="photo-upload-box cnt-2">
                        <p class="tit">
                            우측면
                        </p>
                        <div class="photo-inbox-wrapper cnt-2">
                            <div class="photo-inbox ratio-type-2">
                                <div v-if="imageSrc[6] != null" class="photo-img">
                                    <img v-gallery:detail :src="imageSrc[6]" />
                                    <button
                                        type="button"
                                        class="photo-delete"
                                        style="width: 29px;height: 29px;top:45%;left:45%;"
                                        @click="imageDelete(6)"
                                    >
                                        <span class="blind">사진 삭제</span>
                                    </button>
                                </div>

                                <label v-else class="photo-upload-label" for="photo-upload-6" @click="imageUpload(6)">
                                    <span class="blind">사진 업로드</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="btn-wrapper">
                        <a class="btn btn-cancel" @click="prev()"><span>이전으로</span></a>
                        <a class="btn btn-save" @click="save()"><span>저장</span></a>
                    </div>
                </div>
            </div>
        </main>
        <!-- // content-wrap -->
    </div>
    <!-- // wrap -->
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FacemappingApi from '../api/FacemappingApi';
import FileApi from '../api/FileApi';
import { PICTURE_SORCE_TYPE } from '../const';
import CameraHelper from '../helper/CameraHelper';
import { photoDialog } from '../helper/DialogHelper';

export default {
    name: 'Step2',
    components: {},
    data: () => {
        return {
            id: null,
            data: {},
            imageFileIdMap: {},
            uploadFileIdx: null,
            imageSrc: {
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null
            },
            imageIds: {
                1: null,
                2: null,
                3: null,
                4: null,
                5: null,
                6: null
            }
        };
    },
    computed: {
        ...mapState({})
    },
    beforeCreate() {
        ///////////////////////
        // Initializer Area
        ///////////////////////
        //this.showLoading();
        //this.$store.dispatch('showLoading');
    },
    created() {
        this.id = this.$route.params.id;
    },
    mounted() {
        window.scrollTo(0, 0);
        if (this.id != null) {
            this.dataObj();
        } else {
            this.$router.push({
                name: 'List'
            });
        }
    },
    beforeDestroy() {},
    methods: {
        ...mapActions(['showLoading', 'hideLoading']),
        backbtn() {
            this.$router.push({
                name: 'List'
            });
        },
        home() {
            this.$router.push({
                name: 'Main'
            });
        },
        prevStep() {
            this.$router.push({ path: `/step1/${this.id}` });
        },
        dataObj() {
            this.showLoading();
            FacemappingApi.detail(this.id).then(res => {
                this.data = res.content;
                this.imageSrc[1] = this.data.topImageOriginUrl;
                this.imageSrc[2] = this.data.leftArchImageOriginUrl;
                this.imageSrc[3] = this.data.rightArchImageOriginUrl;
                this.imageSrc[4] = this.data.frontImageOriginUrl;
                this.imageSrc[5] = this.data.leftImageOriginUrl;
                this.imageSrc[6] = this.data.rightImageOriginUrl;

                this.imageIds[1] = this.data.topImageOrigin;
                this.imageIds[2] = this.data.leftArchImageOrigin;
                this.imageIds[3] = this.data.rightArchImageOrigin;
                this.imageIds[4] = this.data.frontImageOrigin;
                this.imageIds[5] = this.data.leftImageOrigin;
                this.imageIds[6] = this.data.rightImageOrigin;

                this.hideLoading();
            });
        },
        prev() {
            this.$router.go(-1);
        },
        save() {
            this.showLoading();
            this.data.topImageOrigin = this.imageIds[1];
            this.data.leftArchImageOrigin = this.imageIds[2];
            this.data.rightArchImageOrigin = this.imageIds[3];
            this.data.frontImageOrigin = this.imageIds[4];
            this.data.leftImageOrigin = this.imageIds[5];
            this.data.rightImageOrigin = this.imageIds[6];
            FacemappingApi.saveMobileImageInfo(this.data).then(res => {
                this.hideLoading();
                this.$router.push({
                    name: 'List'
                });
            });
        },
        imageUpload(idx) {
            this.uploadFileIdx = idx; //현재 이미지 위치
            photoDialog(this.btnCamera, this.btnGallery);
        },
        imageDelete(idx) {
            this.imageIds[idx] = null;
            this.imageSrc[idx] = null;
        },
        btnCamera() {
            CameraHelper.getPicture(PICTURE_SORCE_TYPE.CAMERA, this.cameraImage, err => {
                console.log('fail:' + err);
            });
        },
        btnGallery() {
            CameraHelper.getPicture(PICTURE_SORCE_TYPE.PHOTOLIBRARY, this.cameraImage, err => {
                console.log('fail:' + err);
            });
        },
        cameraImage(fileUrl) {
            const formData = new FormData();
            const now = new Date();
            const imageName = now.getTime() + '.jpg';

            this.imageSrc[this.uploadFileIdx] = fileUrl;

            formData.append('imgFile', CameraHelper.base64ToBlob(fileUrl), imageName);
            formData.append('file_id', '');
            this.showLoading();

            FileApi.imgUpload(formData).then(result => {
                this.imageIds[this.uploadFileIdx] = result.content.fileId;
                this.hideLoading();
            });
        }
    }
};
/*
#wrap > div {
    height: inherit;
}
*/
</script>
